import { memo } from "react";
import type { StarsFieldProps } from "../store/types";

const StarsField = ({ stars }: StarsFieldProps) => {
  return (
    <div className="stars" >
      <div id="starscontainer">
        {stars.map((star) => (
          <div className="single-star" key={star.id} style={star.style}></div>
        ))}
      </div>
    </div>
  );
};

export default memo(StarsField);
